import { render, staticRenderFns } from "./PreGameNoteStep.vue?vue&type=template&id=cf46fa0e&scoped=true"
import script from "./PreGameNoteStep.vue?vue&type=script&lang=js"
export * from "./PreGameNoteStep.vue?vue&type=script&lang=js"
import style0 from "./PreGameNoteStep.vue?vue&type=style&index=0&id=cf46fa0e&prod&scoped=true&lang=css"
import style1 from "./PreGameNoteStep.vue?vue&type=style&index=1&id=cf46fa0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf46fa0e",
  null
  
)

export default component.exports